function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Paso-2",
  transform: "translate(-14.000000, -693.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(14.000000, 693.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18,9 C18,13.970581 13.970581,18 9,18 C4.02941897,18 0,13.970581 0,9 C0,4.02941897 4.02941897,0 9,0 C13.970581,0 18,4.02941897 18,9 Z",
  id: "Path",
  fill: "#AD2943"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,9 C15,12.3138427 12.3138427,15 9,15 C5.68615725,15 3,12.3138427 3,9 C3,5.68615725 5.68615725,3 9,3 C12.3138427,3 15,5.68615725 15,9 Z",
  id: "Path",
  fill: "#EE3446"
}))));

var SvgDotred = function SvgDotred(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotred, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dot red.491d1fa9.svg";
export { ForwardRef as ReactComponent };